.s-user-menu{
  &-wrapper{

  }
  &-toggler{

  }
  // Default trigger
  &-trigger{
    &-avatar{

    }
    &-content{

    }
    &-hello{

    }
    &-name{

    }
    &-icon{

    }
  }
  // Your custom trigger
  &-trigger-slot{

  }
  &-dropdown{
    &-header{
      img{

      }
      &-content{

      }
      &-close{

      }
    }
    &-list{

    }
    &-item{
      &-title{

      }
      &-badge{

      }
    }

  }
  &-inline{
    
  }
}
